module.exports = __webpack_public_path__ + "resources/img/img_dvision8_m.2b652dc734b6066c22fbf65f71e33347.png";